const request = {
    invalid_input: "L'input non è valido. {{details}}",
    general: 'Si è verificato un errore nella richiesta.',
};
export default request;
